import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import ResaAdminOwner from '../../components/ResaAdminPanel';
import SideBarAdmin from '../../components/SideBarAdmin';

import { useAxios } from '../../utils/hook/useAxios';
function AdminResaItemPage() {
  const [email, setEmail] = useState(null);
  const [annonce, setAnnonce] = useState(null);
  const axios = useAxios();
  const { resaId } = useParams();

  useEffect(() => {
    let fetchReviews = async () => {
      try {
        const response = await axios.get(`/reservations/getbyid/${resaId}`);
        if (response.data) {
          setAnnonce(response.data);
        }
      } catch (error) {
        console.error('Erreur lors de la requête Axios :', error);
      }
    };
    fetchReviews();
  }, []);

  return (
    <section className="bg-body-tertiary">
      <div className="container">
        <div className="row">
          <h1 className="mb-3">
            <span className="px-2">{annonce?.status}</span>
          </h1>

          <div className="col-md-3 mb-3 d-none d-sm-block">
            <SideBarAdmin></SideBarAdmin>
          </div>
          <div className="col-md-8 mb-3">
            {annonce && <ResaAdminOwner reservation={annonce}></ResaAdminOwner>}
          </div>
        </div>
      </div>
    </section>
  );
}

export default AdminResaItemPage;
